import React from 'react'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath'
import Slider from 'react-slick';

interface BannerProps {
    apiValues: any;
    // miniBannerValues: any[];
}
const Leadingcompany: React.FC<BannerProps> = ({ apiValues }) => {

    const itemsPerRow = 6;
    const trustedByCards = Array.isArray(apiValues?.trustedByCards) ? apiValues.trustedByCards : [];
    const rows = [];

    for (let i = 0; i < trustedByCards.length; i += itemsPerRow) {
        rows.push(trustedByCards.slice(i, i + itemsPerRow));
    }


    const leadingcompanyslider = {
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 2000,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1170,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 1,
                    dots: false,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: false,
                },
            },
            {
                breakpoint: 0,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: false,
                },
            },
        ],
    };

    return (
        <>
            {/* Leading Companies */}
            <div className="section lead-companies">
                <div className="container">
                    <div className="section-header text-center aos" >
                        <span className="fw-medium text-secondary fs-18 fw-bold mb-2 d-inline-block">
                            {apiValues?.title || "Trusted By"}
                        </span>
                        <h2 className="mb-0 text-[#1D1753]">
                            {/* <span className='text-[#EA1D2A]'>
                            500+ 
                            </span>  */}
                            {apiValues?.description || "global university partners"}
                        </h2>
                        <p className='mb-1 text-[#1D1753]'>
                            {apiValues?.miniDescription || "Access top institutions worldwide with trusted collaborations across leading countries"}
                        </p>
                    </div>
                    <div className="flex flex-col gap-6">
                        {rows.map((row, rowIndex) => (
                            <div
                                key={rowIndex}
                                className={`overflow-hidden whitespace-nowrap w-full`}
                            >
                                <div
                                    className={`flex gap-6 ${rowIndex % 2 === 0 ? "marquee-left" : "marquee-right"
                                        }`}
                                >
                                    {row.map((item: any, index: number) => (
                                        <div key={index} className="flex-shrink-0">
                                            <ImageWithBasePath
                                                source={item?.iconUrl}
                                                className="img-fluid"
                                                width={200}
                                                alt="Img"
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </div>
            {/* /Leading Companies */}
        </>

    )
}

export default Leadingcompany
